import { carouselItems } from '@/mocks/homeData';

const carouselImages = [
  "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20abstract%20visual%20with%20rich%20coral%20and%20gold%20gradients%2C%20silk%20and%20ink%20wash%20inspired%20flowing%20textures%2C%20elegant%20oriental%20merchant%20atmosphere%2C%20no%20text%2C%20warm%20dramatic%20lighting&width=1200&height=600&seq=carousel-1-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Summer%20vibrant%20abstract%20visual%20with%20peach%20and%20golden%20gradients%2C%20tropical%20fruit%20inspired%20geometric%20shapes%2C%20refreshing%20and%20lively%20atmosphere%2C%20modern%20entertainment%20aesthetic%2C%20no%20text%2C%20bright%20warm%20lighting&width=1200&height=600&seq=carousel-2-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Dark%20mysterious%20abstract%20visual%20with%20deep%20shadows%20and%20amber%20accents%2C%20suspenseful%20geometric%20patterns%20like%20puzzle%20pieces%2C%20crime%20thriller%20atmosphere%2C%20no%20text%2C%20dramatic%20contrast%20lighting&width=1200&height=600&seq=carousel-3-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Epic%20celestial%20fantasy%20abstract%20visual%20with%20warm%20golden%20and%20coral%20gradients%2C%20cosmic%20energy%20flows%20and%20starlight%20effects%2C%20cultivation%20anime%20grand%20atmosphere%2C%20no%20text%2C%20majestic%20warm%20lighting&width=1200&height=600&seq=carousel-4-2026&orientation=landscape",
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3">
            编辑力荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            水果视频平台重点策划的深度内容专题
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselItems.map((item, i) => {
            const isAccent = item.color === 'from-accent';
            const overlayClass = isAccent
              ? 'from-accent-500/85 via-accent-600/40 to-accent-700/85'
              : 'from-primary-500/85 via-primary-600/40 to-primary-700/85';
            return (
              <div
                key={i}
                className="group relative rounded-2xl overflow-hidden bg-background-200 cursor-pointer min-h-[280px] md:min-h-[320px] flex"
              >
                <img
                  src={carouselImages[i]}
                  alt={item.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className={`absolute inset-0 bg-gradient-to-br ${overlayClass}`}></div>

                <div className="relative z-10 flex flex-col justify-end p-6 md:p-8 w-full">
                  <span className="self-start inline-block px-2.5 py-1 text-[10px] font-medium rounded-full bg-background-50/20 text-background-50 backdrop-blur-sm mb-3 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="font-heading font-bold text-xl md:text-2xl text-background-50 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-background-50/85 leading-relaxed max-w-lg">
                    {item.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}